import { LoginForm } from "@/components/login/LoginForm";
import { Toaster } from "@/components/ui/toaster";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export function LoginPage() {
    const { session } = useAuth();

    if (session) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div className="flex h-screen w-full items-center justify-center px-4 bg-gradient-to-br from-blue-100 via-indigo-100 to-purple-100">
            <LoginForm />
            <Toaster />
        </div>
    );
}
